import React, { Component } from 'react';

class ComboFiltros extends Component {

    render() {
        const { selectCombo, options, optionSeleccionado, propiedadId, descripcion, filtro, error } = this.props

        return (
            <div className='VistaInstanciaParametro-Filtros-Height'>
                <select value={optionSeleccionado} name="filtros" className="form-control default-select confirmadorAjusteCargoSeccionSuperiorSelect" onChange={(event) => {
                    const index = event.target.selectedIndex;
                    const value = event.target.options[index].value;
                    selectCombo(filtro,value,event.target[index].id)
                }}>
                    <option key={-1} value={-1}>{descripcion}</option>
                    {options && options.length > 0 && options.map((item, index) => { return <option id={propiedadId} key={index} value={item.Id}>{item.Descripcion}</option> })}
                </select>
                {error && <label className="error">Ingrese un valor</label>}
            </div>
        );
    }
}

export default ComboFiltros;